import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const StatusCodeTitle = styled.h1`
  font-size: 3em;
  font-weight: bold;
  text-align: center;
`;

export const StatusCodeMessage = styled.p`
  font-size: 1.5em;
  text-align: center;
`;

export const BackButton = styled.button`
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 4px;
  height: 50px;
  min-width: 100px;

  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #e3e2e2;
  }
`;

export const VerticalDivider = styled.div`
  width: 3px;
  height: 100%;
  background-color: #ccc;
`;